import { get, patch, post, httpDelete } from '../../utils/http';

export const fetchOSProjectInfo = ({ accountId, branchId, projectId, withRanking }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os/info`, { withRanking });

export const editProjectOSSlot = ({ accountId, branchId, projectId, slotId, slot }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os/slots/${slotId}`, slot);

// Cross-account unbook: a Premium client unbooking a supplier's external employee. accountId here
// is the calling (client) account, not the supplier's. Server enforces Premium eligibility, and
// resolves whether unbookReasonId counts as No Show itself (from the account's own unbook
// reasons) — it is not sent from here.
export const crossAccountUnbookOSSlot = ({ accountId, branchId, projectId, slotId, unbookReasonId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os/slots/${slotId}`, {
    unbookReasonId
  });

// The calling account's own cross-account unbookings of its suppliers' employees on this project, each
// under the account's own shift and with its own reason pick. Not part of the project payload.
export const fetchProjectExternalUnbookings = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os/unbookings`);

// Lets the account that originally initiated a cross-account unbooking edit their own reason pick
// after the fact. Only the initiating account can call this successfully.
export const updateCrossAccountUnbookReason = ({ accountId, branchId, projectId, shiftUnbookingId, unbookReasonId }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os/unbookings/${shiftUnbookingId}`, {
    unbookReasonId
  });

// Books supplier employees this account unbooked back into the supplier shift they were unbooked from.
// Reports success per employee instead of failing the request, like the order-applicants booking.
export const rebookOSEmployees = ({
  accountId,
  branchId,
  projectId,
  supplierShiftId,
  clientShiftId,
  employeeIds,
  bypassComplianceWarnings
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/os/book`, {
    supplierShiftId,
    clientShiftId,
    employeeIds,
    ...(bypassComplianceWarnings && { bypassComplianceWarnings })
  });
